import './bottom-sheet.scss';
import React, { useEffect } from 'react';

const BottomSheet = props => {
  const {
    backdrop,
    onClickBackdrop,
    expanded,
    addTopRadius,
    pageContext,
    sixOverSix,
    borderRadius,
    addressEditOrderDetail,
    className = '',
    backdropClassname = '',
    disableBodyScroll,
    disableBodyScrollStrict,
    containerClassName,
  } = props;
  useEffect(() => {
    if (disableBodyScroll) {
      if (expanded) document.body.style.overflow = 'hidden';
      else document.body.style.overflow = 'auto';
    } else if (disableBodyScrollStrict) {
      document.body.style.overflow = 'hidden';
      document.body.classList.add('strictly-disable-scroll');
    }
    return () => {
      document.body.style.overflow = 'auto';
      document.body.classList.remove('strictly-disable-scroll');
    };
  }, [disableBodyScroll, expanded]);
  return (
    <div
      aria-label="bottom-sheet-container"
      className={`bottom-sheet-container ${expanded ? 'bottom-sheet-container-in' : ''} ${
        addressEditOrderDetail ? 'height-expand' : ''
      } ${containerClassName ?? ''}`}
    >
      <React.Fragment>
        {backdrop && expanded && (
          <div
            aria-label="backdrop"
            className={`backdrop  ${expanded ? 'backdrop-in' : ''} ${backdropClassname}`}
            onClick={() => typeof onClickBackdrop === 'function' && onClickBackdrop()}
          ></div>
        )}
        <div
          aria-label="bottom-sheet"
          className={`bottom-sheet bg-color_white ${expanded ? 'bottom-sheet-in' : ''} ${
            addressEditOrderDetail ? 'height-expand' : ''
          } ${sixOverSix ? 'six-over-six-height' : ''} ${addTopRadius ? 'top-border' : ''} ${
            pageContext === 'category' || pageContext === 'search' ? ' top-border' : ''
          } ${borderRadius ? 'border-radius16' : ''} ${className}`}
        >
          {props.children}
        </div>
      </React.Fragment>
    </div>
  );
};

export default BottomSheet;
